import { useRef } from "react";
import { useSelector } from "react-redux";
import { getWindowLock } from "../../../abstract/redux/slice/overlaySlice";
import { hasEmptyNode } from "../../../abstract/redux/slice/structureSlice";
import styles from "./ButtonGenerate.module.scss";

export function ButtonGenerate({ handler, text, id, secondary }) {
  const ref = useRef(null);
  const isEmpty = useSelector(hasEmptyNode);
  const isLocked = useSelector(getWindowLock);
  const data = text.split("\n");

  const handleOnMouseDown = (e) => {
    e?.preventDefault();

    ref?.current?.focus();

    if (!isEmpty) {
      handler();
    } else if (!isLocked) {
      ref?.current?.focus();
    }
  };

  return (
    <div
      id={id ? id : null}
      className={`${styles["container"]} ${secondary ? styles["container--secondary"] : ""} `}>
      <button className={`${styles["style--generate"]}`} ref={ref} onMouseDown={handleOnMouseDown}>
        {data.map((e, index) => (
          <div className={styles["button--text"]} key={`${index} ${e}`}>
            {e}
          </div>
        ))}
      </button>
    </div>
  );
}
